import { POST,postFile } from "../../index";

export const queryOTA = (param) => POST("/v1/TerminalOtaController/queryTree", param);
export const insertOTA = (param) => postFile("/v1/TerminalOtaController/insertOTA", param);
export const updateOTA = (param) => postFile("/v1/TerminalOtaController/updateOTA", param);
export const deleteOTA = (param) => POST("/v1/TerminalOtaController/deleteOTA", param);
export const publishOTA = (param) => POST("/v1/TerminalOtaController/publishOTA", param);
export const cancelOTA = (param) => POST("/v1/TerminalOtaController/cancelOTA", param);
